import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';

export const styles = StyleSheet.create({
  container: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    borderColor: themes.light.brand_blue[3],
    backgroundColor: themes.light.brand_blue[3],
  },
  inactive: {
    borderColor: themes.light.gray_blue[5],
    backgroundColor: themes.light.white[1],
  },
  disabled: {
    borderColor: themes.light.gray_blue[6],
    backgroundColor: themes.light.gray_blue[5],
  },
  image: {
    width: 12,
    height: 9.56,
    tintColor: themes.light.white[1],
  },
  indeterminateImage: {
    width: 12,
    height: 2,
    tintColor: themes.light.gray_blue[6],
    backgroundColor: themes.light.gray_blue[6],
  },
  activeImage: {
    tintColor: themes.light.white[1],
  },
});
